import React              from 'react';
import PropTypes          from 'prop-types';
import Translations       from '../../../../utils/Translations';
import StringHelper       from '../../../../utils/StringHelper';
import TransformingSelect from '../../../Form/TransformingSelect';

class SortingSelect extends React.Component {
	UNSAFE_componentWillMount() {
		this.onChange = this.onChangeHandler.bind(this);
	}

	onChangeHandler(value) {
		this.props.onChange(value);
	}

	render() {
		if (this.props.sorting.length === 0) {
			return null;
		}

		const sorting = this.props.sorting.map(o => ({
			key: o,
			label: Translations.get('VideoGridFilterSorting' + StringHelper.capitalize(o)),
		}));

		return (
			<div className={this.props.additionalClassNames}>
				<label htmlFor="sort" className="video-grid__filter-field-label">
					{Translations.get('VideoGridFilterSorting')}
				</label>
				<span className={'video-grid__filter--select-wrapper' + (!this.props.isMobile ? ' has-arrow' : '')}
				      {...(this.props.isDisabled ? {"aria-disabled": this.props.isDisabled} : {})}
				>
					<TransformingSelect name="sort"
					                    onChange={this.onChange}
					                    isDisabled={this.props.isDisabled}
					                    id="sort"
					                    className="video-grid__filter--select"
					                    options={sorting}
					                    isMobile={this.props.isMobile}
					                    selected={this.props.sort}
					/>
				</span>
			</div>
		);
	}
}

SortingSelect.propTypes = {
	additionalClassNames: PropTypes.string,
	sort:                 PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	isDisabled:           PropTypes.bool,
	isMobile:             PropTypes.bool,
	sorting:              PropTypes.array,
	onChange:             PropTypes.func.isRequired,
};

SortingSelect.defaultProps = {
	additionalClassNames: 'col-md-3 col-sm-6 col-xs-12 video-grid__filter--column',
	sorting:              [],
	isDisabled:           false,
	isMobile:             false,
	sort:                 'guestRating',
};

export default SortingSelect;
